/**
 * Keep auth-related React state aligned with the public session shape only
 * (no password hashes or unknown server fields should live in context).
 */
export function normalizeSessionUser(raw) {
  if (!raw || typeof raw !== 'object') return null;
  return {
    id: raw.id,
    companyId: raw.companyId,
    name: typeof raw.name === 'string' ? raw.name : '',
    email: typeof raw.email === 'string' ? raw.email : '',
    role: typeof raw.role === 'string' && raw.role.trim() ? raw.role.trim().toLowerCase() : 'member',
  };
}
